import { Component } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app-root.component.html",
  styleUrls: ["./app-root.component.scss", "./app-root.component.mobile.scss"]
})
export class AppRootComponent {
  title = "SpaceX";
}
